export enum StatisticGroup {
  MONTH = "month",
  YEAR = "year",
}
